import {DrawerItem as DrawerItemDto} from "@core/model";
import {ButtonBase, Icon, Tooltip, Typography} from "@mui/material";
import {useThemeContext} from "@theme";
import {truncateSx} from "@util";

const DrawerItem = ({
  drawerOpen,
  selected,
  label,
  item,
  onClick,
}: {
  label: string;
  item: DrawerItemDto;
  drawerOpen?: boolean;
  selected: boolean;
  onClick: () => void;
}) => {
  const {theme} = useThemeContext();

  return (
    <ButtonBase
      sx={{
        justifyContent: "start",
        mx: 1,
        p: 1,
        gap: 2,
        borderRadius: 3,
        ...(selected
          ? {backgroundColor: theme.colors.primaryContainer}
          : {"&: hover": {backgroundColor: theme.colors.secondaryContainer}}),
      }}
      onClick={onClick}>
      <Tooltip title={label} enterDelay={drawerOpen ? 9999 : 500}>
        <Icon>{item.icon}</Icon>
      </Tooltip>
      <Typography
        variant="body2"
        fontWeight={selected ? 800 : undefined}
        sx={truncateSx}>
        {label}
      </Typography>
    </ButtonBase>
  );
};

export {DrawerItem};
